













































































import Vue from "vue"
import { postalCodeService, IPostalCodeService } from "@/model/service/postal-codes/postal-codes-service"
import { PostalCode } from "@/model/entity/postal-code/postal-code"
import Datatable, { IDatatable, DatatableOptions } from "@/components/datatable/Datatable.vue"
import { plainToClass } from "class-transformer"
import PostalCodeEditor from "@/components/postal-code/PostalCodeEditor.vue"

export interface IUserAdministrationData {
  postalCodeService: IPostalCodeService
  fields: any
  editorVisible: boolean
  formsValid: boolean
  deleteDialog: boolean
  selectedPostalCodeId: number
  postalCode: PostalCode
  options: DatatableOptions
}

export default Vue.extend({
  components: {
    Datatable,
    PostalCodeEditor
  },
  data(): IUserAdministrationData {
    return {
      options: {
        operations: {}
      },
      postalCodeService: postalCodeService,
      fields: PostalCode.getFieldDescriptionList(),
      editorVisible: false,
      formsValid: false,
      deleteDialog: false,
      selectedPostalCodeId: 0,
      postalCode: new PostalCode()
    }
  },

  methods: {
    addPostalCode() {
      this.editorVisible = true
    },
    savePostalCode() {
      postalCodeService.create(this.postalCode).then(() => {
        this.editorVisible = false
        const dataTable = this.$refs.datatable as IDatatable
        dataTable.refreshData()
      })
    },
    validateForm(isValid: boolean) {
      this.formsValid = isValid
    },
    modelChanged(value: PostalCode) {
      this.postalCode = value
    },
    deletePostalCode(id: number) {
      postalCodeService.delete(id).then(() => {
        const dataTable = this.$refs.datatable as IDatatable
        dataTable.refreshData()
        this.deleteDialog = false
        this.$message({
          message: this.$t("postal_code.postal_code_deleted") as string,
          type: "success"
        })
      })
    },
    openDeleteDialog(selectedPostalCodeId: number) {
        this.deleteDialog = true
        this.selectedPostalCodeId = selectedPostalCodeId
    }
  }
})
